import React from 'react';
import { formatTierLabel, getTierBadgeClass, getTierEmoji } from '../utils/trackerUtils';

export default function TierBadge({ tier, className = '' }) {
  return (
    <span
      className={`inline-flex items-center gap-0.5 px-2 py-0.5 text-xs rounded-full font-semibold whitespace-nowrap ${getTierBadgeClass(tier)} ${className}`}
    >
      {getTierEmoji(tier)} {formatTierLabel(tier)}
    </span>
  );
}
